<template>
  <div>
    <Header/>
    <b-container class="app-main" :class="{warning}">
      <div v-if="warning" class="app-wide-warning">
        <b>Important:</b> Brandly <a href="/support/browserSupport/browsersSupported">requires a recent browser</a> for full functionality. Please try <b>Chrome</b> or <b>FireFox</b>
      </div>
      <slot></slot>
    </b-container>
  </div>
</template>

<style lang="scss" scoped>
.app-main {
  $navbar-height: 0px; // Navbar no longer fixed...

  margin-top: 0;
  padding-top: 1em;
  &.warning {
    padding-top: 0;
  }

  // Extra small devices (portrait phones, less than 576px)
  @media (max-width: 575.98px) {
    padding-top: 0;

    // Eliminate padding from container
    padding-left: 0;
    padding-right: 0;
  }
}
.app-main > .app-wide-warning {
  background: yellow;
  padding: 0.25em 1.5em;
  a { text-decoration: underline;}
}
</style>

<script>
import {mapGetters} from 'vuex';
export default {
  computed: {
    ...mapGetters(['flags']),
    warning() {
      // Return the type of warning. Not currently used,
      // but this could be used for outage alerts etc.
      return this.flags.legacy ? 'legacy' : null;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/AppLayout.vue